import React from 'react';
import styled from "styled-components";
import { OptionalExtraType } from '../../Components/Types';
import AdditionalDriverForm from './AdditionalDriverForm';
import { useMsal } from '@azure/msal-react';
import { Header } from 'Components/PageComponents';
import { toast } from 'react-toastify';
import { toastConfig } from 'Components/Constants';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { VehicleAPI } from 'API/VehicleAPI';
import { OptionalExtraAPI } from 'API/OptionalExtraAPI';

type AdditionalExtrasProps = {
    setOptionalExtras: (optionalExtras: OptionalExtraType[]) => void;
    setwaitingForServer: (value: boolean) => void;
    waitingForServer: boolean;
}
type OptionalExtraBoxProps = {
    $selected: boolean;
}
const OptionalExtraItem = styled.div`
    margin: 10px;
`;
const OptionalExtraBox = styled.button<OptionalExtraBoxProps>`
    display: inline-block;
    height: 18px;
    width: 18px;
    cursor:pointer;
    transition: 0.2s;
    background-color: ${props => props.$selected ? "var(--main-teal-color)" : "#fff"};
    border: 1.5px solid var(--main-teal-color);
        &:hover {
            transition: all 0.2s ease 0s;
            background: var(--main-teal-color);
        }
        :disabled {
              background-color: #cccccc;
              color: #666666;
            :hover {
                background-color: #cccccc;
            }
        }
`;
const OptionalExtraBody = styled.div`
    padding:10px;
    display: inline-block;
    width:80%;
`;
const OptionalExtraTitle = styled.h4`
    font-family: Lato-Black;
    color: var(--main-teal-color);
`;
const OptionalExtraDesc = styled.p`
    font-family: Lato-Regular;
    font-size: 1rem;
`;
function AdditionalExtras({ setOptionalExtras,
     setwaitingForServer,
      waitingForServer }: AdditionalExtrasProps) {
    const { currentBooking } = useSelector((state: RootState) => state.booking);

    const { instance } = useMsal();

    const optionalExtras = currentBooking?.optional_extras ?? [] as OptionalExtraType[];

    const bookingId = currentBooking?.booking_id ?? 0;

    const updateOptionalExtra = async (optionalExtraIdx: number) => {
        setwaitingForServer(true);
        const motorhome = await VehicleAPI.GetVehicle(instance, currentBooking?.vehicle_id ?? 0);
        const added = optionalExtras[optionalExtraIdx].added;

        if (!added && optionalExtras[optionalExtraIdx].check_allow_pet && !motorhome.allow_pet) {
            const message = "This motorhome is not pet friendly. To continue please remove the pet option or book one of our pet-friendly motorhomes.";
            toast.error(message, { ...toastConfig, toastId: message + "-toast" });
            setwaitingForServer(false);
        }
        else {
            try {
                const optionalExtraId = optionalExtras[optionalExtraIdx].vehicle_category_optional_extra_id;
                const additionalDriver = optionalExtras[optionalExtraIdx].additional_driver;
                await OptionalExtraAPI.update(instance, bookingId, optionalExtraId, additionalDriver, added)

                updateList(optionalExtraIdx, !added);
            }
            catch { }
        }
    }

    const updateList = (optionalExtraIdx: number, add: boolean) => {
        const optionalExtrasArr = [...optionalExtras];
        const updatedOe = { ...optionalExtrasArr[optionalExtraIdx] };
        updatedOe.added = add;
        optionalExtrasArr[optionalExtraIdx] = updatedOe;
        optionalExtrasArr[optionalExtraIdx].added = add;
        setOptionalExtras(optionalExtrasArr);
    }

    return (
        <>
            <Header>Optional Extras</Header>
            {optionalExtras.map((optionalExtra: OptionalExtraType, i: number) => {
                return (
                    <React.Fragment key={i}>
                        <OptionalExtraItem>
                            <OptionalExtraBox
                                type="button"
                                disabled={waitingForServer}
                                $selected={optionalExtra.added}
                                onClick={() => updateOptionalExtra(i)}
                            />
                            <OptionalExtraBody>
                                <OptionalExtraTitle>{optionalExtra.optional_extra_description}</OptionalExtraTitle>
                                <OptionalExtraDesc>{optionalExtra.optional_extra_additional_information}</OptionalExtraDesc>
                            </OptionalExtraBody>
                        </OptionalExtraItem>
                        {optionalExtra.added && optionalExtra.additional_driver &&
                            <AdditionalDriverForm />
                        }
                    </React.Fragment>
                );
            })}
        </>

    );
}
export default AdditionalExtras;
